/**
 * Created by Vladimir Budilov on 8/13/16.
 */

export let _REGION = "us-east-1";

export let _IDENTITY_POOL_ID = "us-east-1_8630f0ea-60e1-425e-8943-b85ca89f7703";
export let _USER_POOL_ID = "us-east-1_nGDO7QHjW";
export let _CLIENT_ID = "51rv37rilk02a50adi2c6oe94l";
export let _MOBILE_ANALYTICS_APP_ID = "8ed115bcfac94dfa8e364aa5ef201849";
export let _POOL_DATA = {
    UserPoolId: _USER_POOL_ID,
    ClientId: _CLIENT_ID
};



// WEBPACK FOOTER //
// ./src/providers/properties.service.ts